__turbopack_context__.v({
  "nav": "styles-module__m1JARq__nav",
});
